import { useState } from "react";
import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, LockKeyhole } from "lucide-react";
import "@/App.css";
import Home from "@/pages/Home";
import AlbumPage from "@/AlbumPage";
import AdminWorkspace from "@/AdminWorkspace";
import { setToken, errorText } from "@/adminApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function AdminLogin() {
  const [email, setEmail] = useState("aathreya780@gmail.com");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navg = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(
        `${API}/auth/login`,
        { email, password },
        { withCredentials: true },
      );
      setToken(data.token);
      navg("/admin");
    } catch (x) {
      setError(errorText(x));
    }
  };
  return (
    <main className="admin-login">
      <a href="/" className="wordmark">INFINITE<span>PHOTOGRAPHY</span></a>
      <form onSubmit={submit} data-testid="admin-login-form">
        <LockKeyhole size={22} />
        <p className="eyebrow">PRIVATE STUDIO ACCESS</p>
        <h1>Admin <em>login.</em></h1>
        <label>EMAIL
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" data-testid="admin-email-input" />
        </label>
        <label>PASSWORD
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" data-testid="admin-password-input" />
        </label>
        {error && <p className="error" data-testid="admin-login-error">{error}</p>}
        <button className="gold-btn" data-testid="admin-login-submit-button">LOG IN <ArrowUpRight size={16} /></button>
        <button
          type="button"
          className="reset-link"
          onClick={async () => {
            try {
              await axios.post(`${API}/auth/forgot-password`, { email });
              setError("If authorised, a password setup email has been sent.");
            } catch (x) {
              setError(errorText(x));
            }
          }}
          data-testid="forgot-password-button"
        >
          FORGOT PASSWORD?
        </button>
      </form>
    </main>
  );
}

function AdminReset() {
  const q = new URLSearchParams(window.location.search);
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  return (
    <main className="admin-login">
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            await axios.post(`${API}/auth/reset-password`, {
              email: q.get("email"),
              token: q.get("token"),
              password,
            });
            setMessage("Password created. Return to Admin Login.");
          } catch (x) {
            setMessage(errorText(x));
          }
        }}
        data-testid="admin-reset-form"
      >
        <p className="eyebrow">SECURE PASSWORD SETUP</p>
        <h1>Choose your <em>password.</em></h1>
        <label>NEW PASSWORD
          <input required minLength="10" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-reset-password-input" />
        </label>
        {message && <p className="notice" data-testid="admin-reset-message">{message}</p>}
        <button className="gold-btn" data-testid="admin-reset-submit">CREATE PASSWORD <ArrowUpRight size={16} /></button>
      </form>
    </main>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/album" element={<AlbumPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminWorkspace />} />
        <Route path="/admin/reset" element={<AdminReset />} />
      </Routes>
    </BrowserRouter>
  );
}
